// ===========================================
// TrendChart — Évolution du CA mensuel (Recharts AreaChart)
// ===========================================
import React from 'react';
import { Card, Empty, Skeleton } from 'antd';
import { LineChartOutlined } from '@ant-design/icons';
import {
    AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
} from 'recharts';
import { formatMontant } from '../../../common/utils/format';

const formatYAxisShort = (value) => {
    if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
    if (value >= 1_000) return `${Math.round(value / 1_000)}K`;
    return String(value);
};

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    const v = payload[0].value;
    return (
        <div className="trend-tooltip">
            <div className="trend-tooltip-label">{label}</div>
            <div className="trend-tooltip-value">{formatMontant(v)} F</div>
        </div>
    );
};

const TrendChart = ({ data, loading, title = 'Évolution du CA', subtitle }) => {
    return (
        <Card
            className="dashboard-chart-card"
            title={
                <div className="chart-card-title">
                    <LineChartOutlined />
                    <span>{title}</span>
                </div>
            }
            extra={subtitle && <span className="chart-card-subtitle">{subtitle}</span>}
        >
            {loading ? (
                <Skeleton active paragraph={{ rows: 6 }} />
            ) : !data || data.length === 0 ? (
                <Empty description="Aucune donnée" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            ) : (
                <div className="trend-chart-wrapper">
                    <ResponsiveContainer width="100%" height={280}>
                        <AreaChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                            <defs>
                                <linearGradient id="trendGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%"  stopColor="#1A2B5F" stopOpacity={0.45} />
                                    <stop offset="100%" stopColor="#1A2B5F" stopOpacity={0.02} />
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" stroke="var(--cap-divider)" vertical={false} />
                            <XAxis
                                dataKey="label"
                                tick={{ fontSize: 12, fill: 'var(--cap-text-secondary)' }}
                                axisLine={{ stroke: 'var(--cap-border)' }}
                                tickLine={false}
                            />
                            <YAxis
                                tick={{ fontSize: 11, fill: 'var(--cap-text-secondary)' }}
                                axisLine={false}
                                tickLine={false}
                                tickFormatter={formatYAxisShort}
                                width={50}
                            />
                            <Tooltip content={<CustomTooltip />} />
                            <Area
                                type="monotone"
                                dataKey="total"
                                stroke="#1A2B5F"
                                strokeWidth={2.5}
                                fill="url(#trendGradient)"
                                activeDot={{ r: 5, stroke: '#C8102E', strokeWidth: 2, fill: '#fff' }}
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            )}
        </Card>
    );
};

export default TrendChart;
